// fichier : mm-info-sheets.js
//
// Ouverture / fermeture des bottom sheets (.mm-rayons-sheet) : nav « rayons » de
// la PLP ET info-sheets DDM · prix de réf · Yuka ouvertes depuis la quickview.
//
// Extrait de mm-header-collection.js : ce script n'était chargé que par la
// section header de collection, alors que la quickview qui déclenche les (i)
// vit dans theme.liquid — donc sur toute page. Résultat : sur la home, le clic
// sur un (i) n'était écouté par personne. Il est désormais chargé globalement,
// avec la quickview.
//
// Le bloc entier est gardé par `if (sheets.length)` : sur une page sans sheet
// dans le DOM, le script ne fait rien et ne coûte rien.
// Déclencheur : [data-mm-sheet-open="<id>"] · fermeture : [data-mm-rayons-close],
// swipe vers le bas, ou Échap.
(function () {
  var sheets = document.querySelectorAll('[data-mm-rayons-sheet]');
  if (!sheets.length) return;

  // On deplace les sheets en fin de <body> pour que leur position:fixed + z-index
  // passent au-dessus du header sticky et du contenu, hors du contexte
  // d'empilement de la section qui les a rendues.
  sheets.forEach(function (sheet) {
    if (document.body && sheet.parentNode !== document.body) {
      document.body.appendChild(sheet);
    }
  });

  var setSheet = function (sheetId, open) {
    sheets.forEach(function (sheet) {
      sheet.classList.toggle('is-open', open && sheet.id === sheetId);
    });
    document.documentElement.classList.toggle('stop-scrolling', open);
    document.querySelectorAll('[data-mm-sheet-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', open && button.getAttribute('data-mm-sheet-open') === sheetId ? 'true' : 'false');
    });
    // À chaque ouverture, on remet le scroll interne de la sheet tout en haut
    // (sinon la position de scroll de la fois précédente est conservée).
    if (open) {
      var active = document.getElementById(sheetId);
      if (active) {
        active
          .querySelectorAll('.mm-rayons-sheet-panel, .mm-rayons-sheet-list, .mm-ddm-sheet-body, .mm-priceref-body, .mm-yuka-sheet-body')
          .forEach(function (el) { el.scrollTop = 0; });
      }
    }
  };

  // Fermeture par glissement vers le bas (swipe-to-dismiss) sur chaque sheet.
  // Le drag ne démarre que si le contenu est déjà en haut (sinon on laisse scroller),
  // ou si on attrape la poignée / l'en-tête.
  var CLOSE_THRESHOLD = 90; // px avant de fermer
  sheets.forEach(function (sheet) {
    var panel = sheet.querySelector('.mm-rayons-sheet-panel');
    if (!panel) return;
    var scrollEl = panel.querySelector('.mm-rayons-sheet-list, .mm-ddm-sheet-body, .mm-priceref-body, .mm-yuka-sheet-body');
    var startY = 0, curY = 0, dragging = false, armed = false;

    panel.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { armed = false; return; }
      var atTop = !scrollEl || scrollEl.scrollTop <= 0;
      var onGrip = e.target.closest('.mm-rayons-sheet-handle, .mm-rayons-sheet-header, .mm-ddm-sheet-topbar, .mm-priceref-topbar, .mm-yuka-sheet-topbar');
      armed = atTop || !!onGrip;
      startY = curY = e.touches[0].clientY;
      dragging = false;
    }, { passive: true });

    panel.addEventListener('touchmove', function (e) {
      if (!armed) return;
      curY = e.touches[0].clientY;
      var dy = curY - startY;
      if (dy <= 0) { // vers le haut → on annule un éventuel drag
        if (dragging) { dragging = false; panel.style.transition = ''; panel.style.transform = ''; }
        return;
      }
      if (!dragging && dy > 6) { dragging = true; panel.style.transition = 'none'; }
      if (dragging) {
        if (e.cancelable) e.preventDefault(); // évite le scroll de la page pendant le drag
        panel.style.transform = 'translateY(' + dy + 'px)';
      }
    }, { passive: false });

    var endDrag = function () {
      if (!dragging) { armed = false; return; }
      var dy = curY - startY;
      panel.style.transition = '';
      panel.style.transform = '';
      dragging = false; armed = false;
      if (dy > CLOSE_THRESHOLD) { setSheet(null, false); }
    };
    panel.addEventListener('touchend', endDrag);
    panel.addEventListener('touchcancel', endDrag);
  });

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-mm-sheet-open]');
    if (openButton) {
      event.preventDefault();
      setSheet(openButton.getAttribute('data-mm-sheet-open'), true);
      return;
    }
    if (event.target.closest('[data-mm-rayons-close]')) {
      event.preventDefault();
      setSheet(null, false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && document.querySelector('.mm-rayons-sheet.is-open')) {
      setSheet(null, false);
    }
  });
})();
